import React from "react";
import { ClipboardList, Plus } from "lucide-react";
import { Button } from "../../../components/ui/button";

export function TestPlanHeader({ onAddTestPlan, canAdd = true }) {
  return (
    <div
      className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between"
      data-testid="test-plan-header"
    >
      <div>
        <div className="flex items-center gap-2">
          <ClipboardList className="h-7 w-7 text-violet-600" aria-hidden />
          <h1 className="text-2xl font-bold text-text-primary">Test Plans</h1>
        </div>
        <p className="mt-1 text-sm text-text-secondary">
          Defines the scope, objective, timeline, and configuration of testing
          activities.
        </p>
      </div>
      {canAdd && (
        <Button
          type="button"
          variant="outline"
          onClick={onAddTestPlan}
          className="shrink-0 border-violet-300 text-violet-700 hover:bg-violet-50"
          data-testid="add-test-plan-header-btn"
        >
          <Plus className="mr-2 h-4 w-4" />+ Add Test Plans
        </Button>
      )}
    </div>
  );
}
